import toWebpImage from '@src/utils/to-webp-image';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const pageLocalesData = getPageLocalesData();
const LocalesData = pageLocalesData.mechaUnit;
const stellarisData = LocalesData.feijing;
const lang = getLanguageByPath();

/**
 *  特装机甲数据
 */
export const mechaData = {
  mechaName: toWebpImage(`${require('./images/' + lang + '/warrior-name.png')}`),
  mechaImg: toWebpImage(require('./images/structure.png')),
  driverImg: toWebpImage(require('./images/per.png')),
  iconBadge: toWebpImage(require('./images/icon-badge.png')),
  maLogo: toWebpImage(require('./images/ma-logo.png')),
  btnBack: toWebpImage(require('./images/' + lang + '/btn-back.png')),
  driverStoryTitle: require('./images/' + lang + '/driver-story-title.png'),
  cvTab: [toWebpImage(require('./images/checked1.png')), toWebpImage(require('./images/checked2.png')), toWebpImage(require('./images/checked3.png'))],
  audioScreen: require('./images/audio-screen.png'),
  mechaInfoTitle: require('./images/' + lang + '/mecha-info-title.png'),
  manufacturerTitle: require('./images/' + lang + '/manufacturer-title.png'),
  basicInfoTitle: LocalesData.basicInfoTitle,
  driverVoiceTitle: LocalesData.driverVoiceTitle,
  mechaStorySubTitle: LocalesData.mechaStorySubTitle,
  roleExperSubTitle: stellarisData.roleExperSubTitle,
  driverName: stellarisData.driverName,
  driverType: stellarisData.driverType,
  driversSex: stellarisData.driversSex,
  driversBirthplace: stellarisData.driversBirthplace,
  driversStructure: stellarisData.driversStructure,
  driversRoleExperText: stellarisData.driversRoleExperText,
  mechaInfoType: stellarisData.mechaInfoType,
  mechaInfoNums: stellarisData.mechaInfoNums,
  mechaInfoHeadHigh: stellarisData.mechaInfoHeadHigh,
  mechaInfoEmptyWeight: stellarisData.mechaInfoEmptyWeight,
  mechaInfoTotal: stellarisData.mechaInfoTotal,
  mechaInfoStory: stellarisData.mechaInfoStory,
  manufacturerGruopCh: stellarisData.manufacturerGruopCh,
  cvCH: stellarisData.cvCH,
  cvEN: stellarisData.cvEN,
  cvJA: stellarisData.cvJA,
  zhCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202507/1753153524303_1-Vox_Pilot_Get_Elite_014.wav',
      title: stellarisData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202507/1753153524303_2-Vox_Pilot_Entrance_Elite_014_a.wav',
      title: stellarisData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202507/1753153524303_3-Vox_Pilot_MVP_Elite_014_a.wav',
      title: stellarisData.voice.title3,
      isPlay: false
    }
  ],
  enCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202507/1753153166892_1-Vox_Pilot_Get_Elite_014.wav',
      title: stellarisData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202507/1753153166892_2-Vox_Pilot_Entrance_Elite_014_a.wav',
      title: stellarisData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202507/1753153166892_3-Vox_Pilot_MVP_Elite_014_a.wav',
      title: stellarisData.voice.title3,
      isPlay: false
    }
  ],
  jaCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202507/1753153348602_1-Vox_Pilot_Get_Elite_014.wav',
      title: stellarisData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202507/1753153348602_2-Vox_Pilot_Entrance_Elite_014_a.wav',
      title: stellarisData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202507/1753153348602_3-Vox_Pilot_MVP_Elite_014_a.wav',
      title: stellarisData.voice.title3,
      isPlay: false
    }
  ]
};
